import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'

export const PremiumsMonthly: FC = () => {
  const { t } = useTranslation('premiumsMonthly')

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('premiumsMonthlyHeading')}
      width="wide"
      withPrintButton
    >
    </ContentLayout>
  )
}
